// MUI components
import { styled } from '@mui/material/styles';
import { Box, Stack } from '@mui/material';

export const MainCnt = styled(Box)({
  '& .header': {
    marginBottom: 8,
    '& .labelBox': {
      '& .label': {
        fontWeight: 700,
        fontSize: 14,
        lineHeight: '20px',
        letterSpacing: 0,
        verticalAlign: 'middle',
      },
    },
  },
  '& .separator': {
    margin: '0px 0px',
  },
});

export const AccessItemRow = styled(Stack)({
  height: 48,
  transition: 'all 0.1s ease',
  cursor: 'pointer',

  '& .assigneesSelection': {
    '& .placeholder': {
      fontWeight: 600,
      fontSize: 13,
      lineHeight: '16px',
      color: 'rgba(97, 97, 97, 1)',
    },
  },
  '&:hover': {
    borderTop: '1px solid rgba(0, 0, 0, 0.3)',
    borderBottom: '1px solid rgba(0, 0, 0, 0.3)',
  },
  '& .cell': {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    cursor: 'pointer',
    transition: 'all 0.1s ease',

    '& .deleteIcon': {
      color: 'rgba(0, 0, 0, 0.5)',
    },
    '&:hover': {
      '& .deleteIcon': {
        color: 'rgba(0, 0, 0, 1)',
      },
    },
  },
});

export const AddRow = styled(Box)({
  marginTop: 5,
  '& .label': {
    fontWeight: 700,
    fontSize: 13,
    lineHeight: '100%',
    letterSpacing: 0,
    verticalAlign: 'middle',
    color: 'rgba(78, 72, 250, 1)',
  },
});

export const AccessSelection = styled(Box)({
  padding: '0px 10px',
  '& .permissionItem': {
    padding: '10px',
    cursor: 'pointer',
    borderRadius: 10,
    '& .title': {
      fontWeight: 700,
      fontSize: 14,
      lineHeight: '16px',
      letterSpacing: 0,
      color: 'rgba(66, 66, 66, 1)',
      marginBottom: 5,
    },
    '& .description': {
      fontWeight: 500,
      fontSize: 12,
      lineHeight: '16px',
      letterSpacing: 0,
      color: 'rgba(66, 66, 66, 1)',
    },
  },
});

export const SelectedAccess = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  height: '100%',
  width: '100%',

  '& .dropdownIcon': {
    fontSize: 24,
    color: '#00000099',
    display: 'none',
    marginRight: 20,
  },
  '&:hover': {
    '& .dropdownIcon': {
      display: 'inline-block',
    },
  },
  '& .selectedLabel': {
    fontWeight: 600,
    fontSize: 14,
    lineHeight: '20px',
    letterSpacing: 0,
    color: 'rgba(0, 0, 0, 1)',
    width: '185px',
  },
});

export const AccessorSelector = styled(Stack)({
  '& .dropdownIcon': {
    fontSize: 24,
    color: '#00000099',
    display: 'none',
    marginRight: 20,
  },
  '&:hover': {
    '& .dropdownIcon': {
      display: 'inline-block',
    },
  },
});
